/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import FieldContainer from 'components/layout/FieldContainer';
import { AboutMyselfEditing, LANGUAGE_LEVELS } from './AboutMyselfEditing';
import AboutTag from './AboutTag';
import styles from './AboutMyself.module.scss';
import TextWithHiding from '../../../components/TextWithHiding/TextWithHiding';

const FORM_ID = 'aboutForm';

export const AboutMyself = ({ userProps, isCurrentUser, changeIsLoading, setUserProps }) => {
  const [isEditing, setIsEditing] = useState(false);

  const deleteItem = (index, array, changeData) => {
    changeData(array.filter((elem, i) => i !== index));
  };

  return (
    <FieldContainer
      title="About Myself"
      className={styles.contentBox}
      isCurrentUser={isCurrentUser}
      setIsEditingProfile={setIsEditing}
      isEditingProfile={isEditing}
      formId={FORM_ID}
      containEditFieldButton
    >
      {isEditing ? (
        <AboutMyselfEditing
          userProps={userProps}
          setUserProps={setUserProps}
          setIsEditing={setIsEditing}
          changeIsLoading={changeIsLoading}
        />
      ) : (
        <>
          <div className={styles.itemWrapper}>
            {userProps?.about ? (
              <div className={styles.text}>
                <TextWithHiding text={userProps?.about} />
              </div>
            ) : (
              <div className={styles.noInformation}>
                {isCurrentUser ? 'Add information about myself' : 'No information'}
              </div>
            )}
          </div>
          {userProps?.role_name === 'expert' && (
            <div className={styles.itemWrapper}>
              <div className={styles.textPreview}>Expertise</div>
              {userProps?.expertises ? (
                <div className={styles.interestsList}>
                  {userProps?.expertises?.map((elem, index) => (
                    <AboutTag
                      key={elem.id}
                      tagText={elem.name}
                      index={index}
                      deleteItem={deleteItem}
                      isEditing={isEditing}
                    />
                  ))}
                </div>
              ) : (
                <div className={styles.noInformation}>No information</div>
              )}
            </div>
          )}
          <div className={styles.itemWrapper}>
            <div className={styles.textPreview}>Interests</div>
            <div className={styles.interestsList}>
              {userProps?.interests?.map((elem, index) => (
                <AboutTag
                  key={elem}
                  tagText={elem.body}
                  index={index}
                  deleteItem={deleteItem}
                  isEditing={isEditing}
                />
              ))}
            </div>
          </div>
          <div className={styles.itemWrapper}>
            <div className={styles.textPreview}>Language</div>
            <div className={styles.interestsList}>
              {userProps?.languages?.map((elem, index) => (
                <AboutTag
                  key={elem}
                  tagText={`${elem.language.english_name} - ${
                    LANGUAGE_LEVELS.find((i) => i.key === elem.level).name
                  }`}
                  index={index}
                  deleteItem={deleteItem}
                  isEditing={isEditing}
                />
              ))}
            </div>
          </div>
        </>
      )}
    </FieldContainer>
  );
};
